export function paginationFactory(params: any = {}) {
  const { count, hasNext, hasPrevious, page, totalCount, totalPages } = params;

  return {
    count: count || 0,
    hasNext: hasNext || false,
    hasPrevious: hasPrevious || false,
    page: page || 0,
    totalCount: totalCount || 0,
    totalPages: totalPages || 0,
  };
}
